<template>
    <div class="success-card">
        <div class="project">
            <div class="project-grid">
                <div class="thumbnail">
                    <img :src="`${img_base}${icon}`" alt="project">
                </div>
                <div class="content" :style="isPersonal ? 'min-height: auto !important;' : ''">
                    <p class="title text-center h4 elipsis">{{ projectAlias }}</p>
                    <div class="vs-divider black"></div>
                    <div class="mt-5">
                        <slot name="list"></slot>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import formatHelper from '@mixins/formatHelper';
export default {
    name: "SeedCard",
    props: ["projectAlias", "icon", "isPersonal"],
    mixins: [formatHelper],
    data() {
        return {
            img_base: "https://cdn.redgirasol.com/nuevo_portal/fotografias/foto-"
        }
    },
}

</script>

<style scoped>
.project-grid .content {
    background-color: var(--color-gray-6);
    min-height: 30.4rem;
}

.project-grid {
    box-shadow: none !important;
}

.elipsis {
    width: auto;
    white-space: nowrap;
    text-overflow: ellipsis !important;
    overflow: hidden;
}

    .elipsis:hover {
        color: var(--color-primary)
    }


.thumbnail img {
    height: 13rem;
}
</style>